import React, { Component } from 'react';
import { Query } from 'react-apollo';
import { Table, Row, Cell } from './tableUtils';
import UpdateUser from './updateUser';
import CreateUser from './createUser';
import css from './usersTable.scss';
import { GET_USERS } from './queries';
import { Redirect } from 'react-router';
import FilterEvent from '../filter/filter.event';
import RetrySvg from '../../assets/svgr/retry/retry.svg';
import Infobulle from '../infobulle/infobulle';

class UsersTable extends Component {
	state = {
		filter: null,
	};
	handleFilterEvent = (f) => {
		this.setState((_) => ({ filter: f }));
	};
	componentDidMount() {
		FilterEvent.bind(this.handleFilterEvent);
	}
	componentWillUnmount() {
		FilterEvent.unbind(this.handleFilterEvent);
	}
	render() {
		const authToken = localStorage.getItem('token');
		if (!authToken) {
			return <Redirect to="/" />;
		}
		return [
			<Table key="usersTable">
				<Row head>
					<Cell head type="deleteCol" />
					<Cell head>Nom du Restaurant</Cell>
					<Cell head>Adresse du Restaurant</Cell>
					<Cell head>Prénom du Contact</Cell>
					<Cell head>Nom du Contact</Cell>
					<Cell head>Fonction</Cell>
					<Cell head>Téléphone</Cell>
					<Cell head type="email">
						Email
					</Cell>
					<Cell head>
						<Infobulle>
							<RetrySvg type="head" />
						</Infobulle>
					</Cell>
				</Row>
				<Query query={GET_USERS}>
					{({ loading, error, data }) => {
						if (loading) {
							return <div className={css.error}>Loading</div>;
						}
						if (error) {
							return (
								<div className={css.error}>
									Une erreur est survenue :{' '}
									<strong>
										{error.graphQLErrors[0]
											? error.graphQLErrors[0].message
											: 'Unknown Error'}
									</strong>
								</div>
							);
						}
						if (this.state.filter) {
							data.users = data.users.sort((a, b) => {
								const aValue = a[this.state.filter];
								const bValue = b[this.state.filter];
								// Handle null/undefined values
								if (!aValue && !bValue) return 0;
								if (!aValue) return 1;
								if (!bValue) return -1;
								return aValue.toLowerCase().localeCompare(bValue.toLowerCase());
							});
						}
						return [
							<CreateUser key="create" />,
							data.users.map((data, i) => (
								<UpdateUser key={data.id} {...data} />
							)),
						];
					}}
				</Query>
			</Table>,
		];
	}
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/usersTable/usersTable.js